import { ISettings, SETTINGS_DEFAULT } from "@/shared";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useSettingsStore = defineStore("settings", () => {
	// data
	const settings = ref<ISettings>({ ...SETTINGS_DEFAULT });

	// methods
	function init(): void {
		const storage = localStorage.getItem("fluxbeam:v1:settings");

		if (!storage) return;

		settings.value = {
			...settings.value,
			...JSON.parse(storage),
		};
	}
	function update(): void {
		localStorage.setItem(
			"fluxbeam:v1:settings",
			JSON.stringify(settings.value)
		);
	}

	function reset(): void {
		localStorage.removeItem("fluxbeam:v1:settings");
		settings.value.explorerOpens = SETTINGS_DEFAULT.explorerOpens;
		settings.value.explorer = SETTINGS_DEFAULT.explorer;
		settings.value.customRpcUrl = SETTINGS_DEFAULT.customRpcUrl;
		settings.value.slippage = SETTINGS_DEFAULT.slippage;
		settings.value.validatorTip = SETTINGS_DEFAULT.validatorTip;
		settings.value.priorityFeeMax = SETTINGS_DEFAULT.priorityFeeMax;
		settings.value.priorityLevel = SETTINGS_DEFAULT.priorityLevel;
		settings.value.swapValues = SETTINGS_DEFAULT.swapValues;
	}

	// setup
	init();

	// getter
	const getSettings = computed<ISettings>(() => settings.value);
	const getSwapSellValuesSorted = computed<number[]>(()=>{
		return settings.value.swapValues.sell
	})
	const getSwapBuyValuesSorted = computed<number[]>(()=>{
		return settings.value.swapValues.buy
	})

	return { settings, init, update, reset, getSettings, getSwapSellValuesSorted, getSwapBuyValuesSorted };
});
